export default {"src":"/_next/static/media/Image_blur.6ba0cb3c.svg","height":200,"width":200,"blurWidth":0,"blurHeight":0};